import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Grid, makeStyles } from '@material-ui/core';
import { useMeContext } from '~/modules/me';
import { ReadOnlyHours } from '~/modules/common/components';

const useStyles = makeStyles({
  dataCell: {},
  overriddenCell: {},
  strikeThrough: {},
  paddedCell: {}
});

export const WorkRemainingHours = ({
  classes: classesOverride,
  hoursRemaining,
  overrideValue,
  dataQeId,
  showOverride = typeof overrideValue === 'number' &&
    overrideValue !== hoursRemaining,
  align = 'right'
}) => {
  const {
    featureFlags: { isPsaSmartBeatPageEnabled }
  } = useMeContext();
  const classes = useStyles({ classes: classesOverride });

  return isPsaSmartBeatPageEnabled ? (
    <ReadOnlyHours
      className={classNames(classes.dataCell)}
      value={hoursRemaining}
      precision={2}
      dataQeId={dataQeId}
      align={align}
    />
  ) : (
    <Grid container direction="column">
      <Grid item>
        <ReadOnlyHours
          className={classNames(
            classes.dataCell,
            showOverride && classes.overriddenCell,
            showOverride && classes.strikeThrough,
            classes.paddedCell
          )}
          value={hoursRemaining}
          precision={2}
          dataQeId={dataQeId}
        />
      </Grid>
      {showOverride && (
        <Grid item>
          <ReadOnlyHours
            className={classNames(
              classes.dataCell,
              classes.overriddenCell,
              classes.paddedCell
            )}
            value={overrideValue}
            precision={2}
            dataQeId={`${dataQeId}_override`}
          />
        </Grid>
      )}
    </Grid>
  );
};

WorkRemainingHours.propTypes = {
  dataQeId: PropTypes.string,
  classes: PropTypes.object,
  hoursRemaining: PropTypes.number,
  overrideValue: PropTypes.number,
  showOverride: PropTypes.bool,
  align: PropTypes.string
};

export default WorkRemainingHours;
